import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AnswerType,
  Demander,
  FormClassRetire,
  MultiplyingFactor,
  Prefectures,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP018_Response } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_APP010, httpAPI_APP018 } from "./api/request";
import { MaePeriod } from "./components/components";
import { makeFormList } from "./hooks/useTools";
import {
  contractorSchema,
  lawyerSchema,
  schema,
  staffSchema,
  tableListAnswer,
  tableListAnswerFor00,
  tableListContractor,
  tableListLawyer,
  tableListStaff,
} from "./parts";
import _ from "lodash";

/**
 * SCRC060134 退職手当金支給予定額の証明依頼書
 * @return SCRC060134
 */
const SCRC060134 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [res, setRes] = useState<IAPI_APP018_Response>({});
  const [open, setOpen] = useState<boolean>(false);
  const [demanderKbn, setDemanderKbn] = useState<string>();
  const [finalSchema, setFinalSchema] = useState<any>([]);
  const [showButton, setShowButton] = useState(false);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const applyId = location.state?.applyId;

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallApiInit = async () => {
    // 退職手当金支給決定額の証明依頼 参照API呼び出し
    try {
      const res = await httpAPI_APP018({
        applyId: parseInt(applyId),
      });

      if (res.resultCd === "I0000") {
        setFakeTable(res);
        setRes(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setFakeTable = (
    res: IAPI_APP018_Response,
    decisionDemanderKbn?: string,
    count?: number
  ) => {
    setState({
      ...state,
      errorMsgId: "",
    });
    //上
    if (decisionDemanderKbn !== undefined) {
      res.decisionDemanderKbn = decisionDemanderKbn;
    }
    let kbn = res.decisionDemanderKbn;
    let table: any[] = [];
    let tempSchema: any = [];
    switch (kbn) {
      case Demander["共済契約者"]:
        table = _.cloneDeep(tableListContractor);
        tempSchema = { ...schema, ...contractorSchema };
        break;
      case Demander["法人職員"]:
        table = _.cloneDeep(tableListStaff);
        tempSchema = { ...schema, ...staffSchema };
        break;
      case Demander["弁護士"]:
        table = _.cloneDeep(tableListLawyer);
        tempSchema = { ...schema, ...lawyerSchema };
        break;
      default:
    }
    if (table.length === 0) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    }

    let demanderKbn = table.find(
      (item) => item.keyword === "decisionDemanderKbn"
    )!;

    // 請求者選択
    setDemanderKbn(res.decisionDemanderKbn);
    setFinalSchema(tempSchema);
    let a = 1;
    demanderKbn.onGetValue = (event: any) => {
      setDemanderKbn(event);
      setFakeTable(res, event, a);
    };

    // 職員住所（法人職員）
    let staffAddress = table.find((item) => item.keyword === "staffAddress");

    if (staffAddress) {
      staffAddress.valueObject = {
        prefectures: TkGetCode(Prefectures, res.prefectureCd),
        city: res.addressCity,
        address: res.addressOthers,
      };
    }
    let zipcode = table.find((item) => item.keyword === "zipcode");
    if (zipcode && staffAddress) {
      zipcode.getPostalCodeValue = (value: any) =>
        getPostalCodeValue(value, staffAddress);
      zipcode.getPostalCodeError = getPostalCodeError;
    }

    // 送付先住所
    let deliveryAddress = table.find(
      (item) => item.keyword === "deliveryAddress"
    )!;

    if (deliveryAddress) {
      deliveryAddress.valueObject = {
        prefectures: TkGetCode(Prefectures, res.deliveryPrefecture),
        city: res.deliveryAddressCity,
        address: res.deliveryAddressOthers,
      };
    }
    let deliveryZipcode = table.find(
      (item) => item.keyword === "deliveryZipcode"
    );

    if (deliveryZipcode && deliveryAddress) {
      deliveryZipcode.getPostalCodeValue = (value: any) =>
        getPostalCodeValue(value, deliveryAddress);
      deliveryZipcode.getPostalCodeError = getPostalCodeError;
    }
    //下
    let tableListAnswerArr = tableListAnswer;

    if (res.latestApplyStatus === Status["処理完了"]) {
      if (res.answerPossibilityFlg === AnswerType["回答不可"]) {
        tableListAnswerArr = tableListAnswerFor00;
      }
    }

    switch (res.latestApplyStatus) {
      //最新申請状態が"00"(届出待ち)の場合
      //最新申請状態が"00"(差戻し一時保存)の場合
      case Status["届出待ち"]:
      case Status["差戻し一時保存"]:
        setShowButton(true);
        table.forEach((item) => (item.disabled = false));
        break;
      //最新申請状態が"13"(処理完了)の場合
      case Status["処理完了"]:
        tableListAnswerArr.forEach((item) => {
          item.disabled = true;
          item.showLine = true;
        });
        break;
      default:
        break;
    }

    //制度改正加入年月日
    let firstJoinDate1 = tableListAnswerArr.find(
      (item) => item.keyword === "firstJoinDate1"
    )!;

    let firstJoinDate2 = tableListAnswerArr.find(
      (item) => item.keyword === "firstJoinDate2"
    )!;
    firstJoinDate1 && (firstJoinDate1.setDefaultValue = res.firstJoinDate);
    firstJoinDate2 && (firstJoinDate2.setDefaultValue = res.firstJoinDate);
    //仮退職年月日
    let tentativeRetireDate1 = tableListAnswerArr.find(
      (item) => item.keyword === "tentativeRetireDate1"
    )!;

    let tentativeRetireDate2 = tableListAnswerArr.find(
      (item) => item.keyword === "tentativeRetireDate2"
    )!;
    tentativeRetireDate1 &&
      (tentativeRetireDate1.setDefaultValue = res.retirePlanDay1);
    tentativeRetireDate2 &&
      (tentativeRetireDate2.setDefaultValue = res.retirePlanDay2);
    //被共済職員期間①
    let maePeriod1 = tableListAnswerArr.find(
      (item) => item.keyword === "maePeriod1"
    )!;

    let maePeriod2 = tableListAnswerArr.find(
      (item) => item.keyword === "maePeriod2"
    )!;

    maePeriod1 &&
      (maePeriod1.node = (
        <MaePeriod
          year={res.maePeriodYear1}
          month={res.maePeriodMonth1}
          disabled={maePeriod1.disabled}
        />
      ));
    maePeriod2 &&
      (maePeriod2.node = (
        <MaePeriod
          year={
            decisionDemanderKbn && Status["届出待ち"] ? "" : res.maePeriodYear1
          }
          month={
            decisionDemanderKbn && Status["届出待ち"] ? "" : res.maePeriodMonth1
          }
          disabled={
            decisionDemanderKbn && Status["届出待ち"] ? "" : maePeriod2.disabled
          }
        />
      ));

    //支給乗率①が"1"(普通退職の乗率を適用)の場合
    let retirementAllowanceExpectAmt1 = tableListAnswerArr.find(
      (item) => item.keyword === "retirementAllowanceExpectAmt1"
    );
    if (res.paymentMultiplierKbn1 && retirementAllowanceExpectAmt1) {
      retirementAllowanceExpectAmt1.setDefaultValue =
        res.paymentMultiplierKbn1 === MultiplyingFactor["普通退職の乗率を適用"]
          ? res.retirementAllowanceExpectAmtGeneral1
          : res.retirementAllowanceExpectAmtHc1;
    }
    //支給乗率②が"1"(普通退職の乗率を適用)の場合
    let retirementAllowanceExpectAmt2 = tableListAnswerArr.find(
      (item) => item.keyword === "retirementAllowanceExpectAmt2"
    );
    if (res.paymentMultiplierKbn2 && retirementAllowanceExpectAmt2) {
      retirementAllowanceExpectAmt2.setDefaultValue =
        res.paymentMultiplierKbn2 === MultiplyingFactor["普通退職の乗率を適用"]
          ? res.retirementAllowanceExpectAmtGeneral2
          : res.retirementAllowanceExpectAmtHc2;
    }

    if (res.latestApplyStatus === Status["処理完了"]) {
      table = [...table, ...tableListAnswerArr];
    }

    // 初期表示
    for (const [key, value] of Object.entries(res)) {
      const targetObj = table.find(
        (item: any) =>
          item.keyword === key &&
          !["lineTitle", "node", "nodeInLine"].includes(item.type)
      );
      if (value !== null && targetObj) {
        if (
          key === "noAnswerReason" &&
          res.answerPossibilityFlg === AnswerType["回答可能"]
        ) {
          targetObj.showLine = false;
        }
        targetObj.setDefaultValue = value;
      }
    }

    let lawyerName = table.find((item) => item.keyword === "lawyerName");
    if (count === undefined) {
      if (res.decisionDemanderKbn === Demander["共済契約者"]) {
        let sixMonthSalaryAverage1Contractor = table.find(
          (item) => item.keyword === "sixMonthSalaryAverage1Contractor"
        );
        sixMonthSalaryAverage1Contractor.setDefaultValue =
          res.sixMonthSalaryAverage1;
      } else if (res.decisionDemanderKbn === Demander["法人職員"]) {
        let sixMonthSalaryAverage1Staff = table.find(
          (item) => item.keyword === "sixMonthSalaryAverage1Staff"
        );
        sixMonthSalaryAverage1Staff.setDefaultValue =
          res.sixMonthSalaryAverage1;
      } else if (res.decisionDemanderKbn === Demander["弁護士"]) {
        let sixMonthSalaryAverage1Lawyer = table.find(
          (item) => item.keyword === "sixMonthSalaryAverage1Lawyer"
        );
        sixMonthSalaryAverage1Lawyer.setDefaultValue =
          res.sixMonthSalaryAverage1;
      }
    }

    if (res.barAssociationName && lawyerName) {
      lawyerName.setDefaultValue = res.barAssociationName;

      lawyerName.disabled =
        res.latestApplyStatus !== Status["届出待ち"] &&
        res.latestApplyStatus !== Status["差戻し一時保存"];
    }

    let lawyerNo = table.find((item) => item.keyword === "lawyerNo");
    if (res.barAssociationRegistNo && lawyerNo) {
      lawyerNo.setDefaultValue = res.barAssociationRegistNo;
    }

    // ファイルリスト
    let formList = res.formList;

    if (formList) {
      // 委任状 弁護士
      const commission = table.find((item) => item.keyword === "commission");

      // 退職支給証明依頼者の身分証明書（写） 法人職員
      const identification = table.find(
        (item) => item.keyword === "identification"
      );

      // 仮退職年月日以前６ヶ月の給与台帳（写） 弁護士/法人職員/共済契約者
      const payroll = table.find((item) => item.keyword === "payroll");

      const switchComType = (com: any, data: any) => {
        const status: any = res.latestApplyStatus;

        if (
          status === Status["届出待ち"] ||
          status === Status["差戻し一時保存"]
        ) {
          com.type = "fileUpload";
          com.setDefaultValue = [
            { formName: data.fileName, fileBase64: data.fileBase64 },
          ];
        } else {
          com.type = "downloadLink";
          com.dataname = data.fileName;
          com.base64filedata = data.fileBase64;
          com.downloadBase64 = true;
        }
      };

      formList.forEach((item: any) => {
        const rule = [
          FormClassRetire["退職支給証明依頼の委任状"],
          FormClassRetire["退職支給証明依頼者の身分証明書（写）"],
          FormClassRetire["仮退職年月日以前6ヶ月の給与台帳（写）"],
        ];
        if (!rule.includes(item.formClass)) {
          return;
        }

        const strategyMap: any = {
          [FormClassRetire["退職支給証明依頼の委任状"]]: () => {
            if (commission) {
              switchComType(commission, item);
            }
          },
          [FormClassRetire["退職支給証明依頼者の身分証明書（写）"]]: () => {
            if (identification) {
              switchComType(identification, item);
            }
          },
          [FormClassRetire["仮退職年月日以前6ヶ月の給与台帳（写）"]]: {
            [Demander["共済契約者"]]: () => {
              if (payroll) {
                switchComType(payroll, item);
              }
            },
            [Demander["法人職員"]]: () => {
              if (payroll) {
                switchComType(payroll, item);
              }
            },
            [Demander["弁護士"]]: () => {
              if (payroll) {
                switchComType(payroll, item);
              }
            },
          },
        };

        const file = strategyMap[item.formClass];
        if (typeof file === "object") {
          const rule: any = [
            Demander["共済契約者"],
            Demander["法人職員"],
            Demander["弁護士"],
          ];

          if (rule.includes(res.decisionDemanderKbn ?? "")) {
            file[res.decisionDemanderKbn!]();
          }
        } else {
          file();
        }
      });
    }

    // 勤務先
    const workPlace = table.find((item) => item.keyword === "workPlace");
    // 被共済者名
    const answerStaffName = table.find(
      (item) => item.keyword === "answerStaffName"
    );
    // 生年月日
    const answerBirthday = table.find(
      (item) => item.keyword === "answerBirthday"
    );

    workPlace && (workPlace.setDefaultValue = res.facilityName);
    answerStaffName && (answerStaffName.setDefaultValue = res.staffName);
    answerBirthday && (answerBirthday.setDefaultValue = res.staffBirthday);

    if (decisionDemanderKbn) {
      table.forEach((item) => {
        if (item.keyword === "decisionDemanderKbn") {
          demanderKbn.setDefaultValue = kbn;
          return;
        }

        if (item.valueObject) {
          item.valueObject = { address: "", city: "", prefectures: "" };
          return;
        }
        item.setDefaultValue = "";
      });
      setStateTableList([...table]);
      return;
    }

    setStateTableList([...table]);
  };

  const getPostalCodeValue = (value: any, address: any) => {
    const data = value.value;
    address.valueObject = {
      prefectures: data.address1,
      city: `${data.address2}${data.address3}`,
      address: "",
    };
    setState({
      ...state,
      errorMsgId: "",
    });
  };
  const getPostalCodeError = (value: any) => {
    setState({
      ...state,
      errorMsgId: value,
    });
  };

  const makeReqUpdate = (data: any): any => {
    let sixMonthSalaryAverage1 = "";
    if (demanderKbn === Demander["共済契約者"]) {
      sixMonthSalaryAverage1 = data.sixMonthSalaryAverage1Contractor;
    }
    if (demanderKbn === Demander["法人職員"]) {
      sixMonthSalaryAverage1 = data.sixMonthSalaryAverage1Staff;
    }
    if (demanderKbn === Demander["弁護士"]) {
      sixMonthSalaryAverage1 = data.sixMonthSalaryAverage1Lawyer;
    }
    let reqObj: any = {
      applyId: res.applyId,
      contractorName: data.contractorName,
      staffName: data.staffName,
      staffNo: data.staffNo ?? res.staffNo ?? "",
      retirePlanDay1: data.retirePlanDay1,
      retirePlanDay2: data.retirePlanDay2,
      requestReason: data.requestReason, // 依頼理由
      decisionDemanderKbn: demanderKbn,
      sixMonthSalaryAverage1: sixMonthSalaryAverage1,
      sixMonthSalaryAverage2: data.sixMonthSalaryAverage2,
      screenId: "SCRC060134",
      baseContractorNo: res.contractorNo,
    };

    switch (demanderKbn) {
      case Demander["共済契約者"]:
        reqObj = {
          ...reqObj,
          unaccountedMonthsTotal1: data.unaccountedMonthsTotal1,
          unaccountedMonthsTotal2: data.unaccountedMonthsTotal2,
          contractorNo: data.contractorNo,
          directorName: data.directorName,
          name: data.demanderName,
          contractorTel: res.contractorTel,
          formList: makeFormList(
            data.payroll,
            undefined,
            undefined,
            res?.facilityNo,
            res?.staffNo
          ), //ファイルリスト
        };
        break;
      case Demander["法人職員"]:
        reqObj = {
          ...reqObj,
          unaccountedMonthsTotal1: 0,
          unaccountedMonthsTotal2: null,
          formList: makeFormList(
            data.payroll,
            data.identification,
            undefined,
            res?.facilityNo,
            res?.staffNo
          ), //ファイルリスト
          zipcode: data.zipcode, // 職員住所郵便番号
          prefectureCd:
            Prefectures[
              data.staffAddress?.prefectures as keyof typeof Prefectures
            ], // 職員住所(都道府県)
          addressCity: data.staffAddress?.city, // 職員住所(市区町村)
          addressOthers: data.staffAddress?.address, // 職員住所(その他)
        };
        break;
      case Demander["弁護士"]:
        reqObj = {
          ...reqObj,
          unaccountedMonthsTotal1: 0,
          unaccountedMonthsTotal2: null,
          formList: makeFormList(
            data.payroll,
            undefined,
            data.commission,
            res?.facilityNo,
            res?.staffNo
          ), //ファイルリスト
          zipcode: data.zipcode, // 職員住所郵便番号
          prefectureCd:
            Prefectures[
              data.staffAddress?.prefectures as keyof typeof Prefectures
            ], // 職員住所(都道府県)
          addressCity: data.staffAddress?.city, // 職員住所(市区町村)
          addressOthers: data.staffAddress?.address, // 職員住所(その他)
          facilityName: data.facilityName, // 施設名
          birthday: data.birthday, // 生年月日
          deliveryTel: res.deliveryTel, // 連絡先電話番号
          deliveryZipcode: data.deliveryZipcode, // 返送先住所（郵便番号）
          deliveryPrefecture:
            Prefectures[
              data.deliveryAddress?.prefectures as keyof typeof Prefectures
            ], // 返送先住所（都道府県）
          deliveryAddressCity: data.deliveryAddress?.city, // 返送先住所（市区町村）
          deliveryAddressOthers: data.deliveryAddress?.address, // 返送先住所（その他）
          barAssociationName: data.barAssociationName, // 所属弁護士会名
          barAssociationRegistNo: data.barAssociationRegistNo, // 所属弁護士会 登録番号
        };
        break;
      default:
        break;
    }

    isKiko && (reqObj.receptionDate = data.receptionDate);
    return reqObj;
  };

  const handleSubmit = async (data: any) => {
    try {
      // 退職手当金支給決定額の証明依頼　更新API 呼び出し
      const res = await httpAPI_APP010(makeReqUpdate(data));

      if (res.resultCd === "I0000") {
        setOpen(true);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  function handleDialogOk() {
    setOpen(false);
    navigate("/SCRC070008");
  }

  return (
    <Box className="SCRC060134" data-testid="SCRC060134">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={finalSchema}
        buttonGroup={
          <Box className="button">
            <TkBackButton />
          </Box>
        }
        submitButtonText={"登録"}
        showButton={showButton}
        onCheckAndSubmit={handleSubmit}
      />

      <TkMessageDialog
        open={open}
        onOky={handleDialogOk}
        title="登録完了"
        contextText="登録が完了しました"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060134;
